module.exports = __webpack_public_path__ + "img/stock7.18fee8a1.png";